module.exports = __webpack_public_path__ + "img/sc_back_transparent.0e20d1f3.png";